import { Box, HStack, SkeletonProps, Stack } from "@chakra-ui/react";

import { Skeleton, SkeletonCircle } from "../skeleton";

export const TableSkeletonRow = () => {
  return (
    <Box mb={6}>
      <HStack gap="5">
        <SkeletonCircle size="8" mx={3} />
        <Stack flex="1">
          <Skeleton height="5" />
        </Stack>
      </HStack>
    </Box>
  );
};

export const TableSkeleton = ({
  rows = 20,
  ...defaultProps
}: {
  rows?: number;
} & SkeletonProps) => {
  return (
    <Skeleton loading={false} {...defaultProps}>
      {Array(rows)
        .fill(0)
        .map((_, idx) => (
          <TableSkeletonRow key={idx} />
        ))}
    </Skeleton>
  );
};
